import explore_image from '@/public/features/explore.webp';
import app_2 from '@/public/features/field_service_managment/App_2.webp';
import schedule_4 from '@/public/features/field_service_managment/Communication-Tools.webp';
import schedule_2 from '@/public/features/field_service_managment/communication-tools-6611717534eae.webp';
import schedule_6 from '@/public/features/field_service_managment/Customizable Forms for Efficient Record-keeping.webp';
import schedule_5 from '@/public/features/field_service_managment/Efficient-Route-Planning.webp';
import bg from '@/public/features/field_service_managment/Frame 1171278053.webp';
import schedule_1 from '@/public/features/field_service_managment/Manage Your Staff Efficiently.webp';
import schedule_3 from '@/public/features/field_service_managment/On-the-Go Job Managment.webp';
import app_1 from '@/public/features/gps_tracking/App_1.webp';
import { CalendarIcon, CardIcon, ToolsIcon, WalletIcon } from '@/public/icons';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Field Service App',
  description: `Our free field service app caters to mobile solutions for managing technicians effectively with seamless operations. Get on board to have all these features turn from intuitive to real-time updates to maximize productivity and so much more. Don't miss out on this app!`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Optimize Your',
  second_title: 'Field Service Management',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: `How Will a Field Service Management App Benefit My Business?`,
      text: `The apps for service technicians streamline your operations by making them simpler, communicating better, and being more efficient. From scheduling and dispatch up to task tracking, the field service engineer app should, therefore, assure greater customer satisfaction and better productivity of field service engineers.`,
    },
    {
      title: `How Does the Field Service App Help with Asset Management?`,
      text: `Asset management features incorporated in the best field service app helps track and handle equipment inventory and maintenance schedules of the same. This ensures optimal performance and reduced risk of downtime, thus boosting the general efficiency of your field operations.`,
    },
    {
      title: `Is Orcatec Field Service App Free?`,
      text: `Yes, Orcatec offers a free version of its field service technician app. It provides essential features to help you manage your field operations efficiently. For advanced features and customization, you can explore our field service management mobile app premium plans.`,
    },
    // {
    //   title: `What Are the Benefits of Using Accounting Software for Service Contractors?`,
    //   text: `Accounting software for service contractors automatedly makes ease in financial management through the management of expenses, tracking invoices, and payrolls. It also provides a very detailed financial statement with increased accuracy and time-saving; this can help contractors make wise business decisions in order to maximize profits.`,
    // },
  ],
};

const testimonals = {
  title: 'Client’s Testimonials',
  description: '',
  items: [
    {
      text: `Orcatec has transformed the way we manage our field operations. Before we were floundering with communication, while the job details were hard to keep with us, yet today everything is brought to us very quickly.`,
      name: 'Lisa M.',
      position: 'Plumbing Business Owner',
    },
    {
      text: `Linking our profiles has raised our visibility for even more clients. Customers can easily leave positive reviews, which helps us build trust and credibility online. It’s a fantastic feature that integrates seamlessly with our workflow.`,
      name: 'Michael T.',
      position: 'Electrical Services Manager',
    },
    {
      text: `With Orcatec, managing reviews is so simple. Our brand trust has significantly increased, and we’re seeing more repeat business. The detailed reporting and automated responses make the whole process smooth and efficient.`,
      name: 'Sarah K.',
      position: 'Field Service Coordinator',
    },

    {
      text: `Orcatec has transformed the way we manage our field operations. Before we were floundering with communication, while the job details were hard to keep with us, yet today everything is brought to us very quickly.`,
      name: 'Lisa M.',
      position: 'Plumbing Business Owner',
    },
    {
      text: `Linking our profiles has raised our visibility for even more clients. Customers can easily leave positive reviews, which helps us build trust and credibility online. It’s a fantastic feature that integrates seamlessly with our workflow.`,
      name: 'Michael T.',
      position: 'Electrical Services Manager',
    },
    {
      text: `With Orcatec, managing reviews is so simple. Our brand trust has significantly increased, and we’re seeing more repeat business. The detailed reporting and automated responses make the whole process smooth and efficient.`,
      name: 'Sarah K.',
      position: 'Field Service Coordinator',
    },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Here, you will find articles, expert insights, and trends in field service management. Tailored to get you on the road to make operations great, be productive, and get ahead in the competitive field service industry.`,
};

const bookDemo = {
  title: `It can't be easier than this to transform\xa0your\xa0field\xa0service\xa0operations`,
  description: `Take the next step toward efficiency and excellence by giving Orcatec's free apps for service technicians a try today. Automatically optimize your workflow, improve communication, and productivity – all done on one powerful platform and in an extremely easy-to-use manner.`,
};

const articles = {
  title: `How Does Field Service Management\xa0App\xa0Work?`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'On-Site Proposal Creation',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Organized Daily Schedule',
      text: `A field service management app provides a detailed, organized daily plan for each technician. It includes all scheduled tasks, appointments, and deadlines, presented in a user-friendly format. This ensures that technicians know exactly what needs to be done each day, minimizing confusion and improving productivity.`,
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Real-Time Updates',
      text: `The app keeps everyone in the loop with real-time updates. As new tasks are assigned or existing ones are updated, technicians receive instant notifications. This feature helps teams respond quickly to changes, reducing downtime and ensuring that customers receive timely service.`,
    },
    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Streamlined Approval Process',
      },
      list: [],
      href: '#',
      tag: '',
      title: `Task Progress and Management`,
      text: `Technicians can add detailed notes, attach relevant documents or photos, and leave comments directly within the app. They can also mark tasks and jobs as completed in real-time. This functionality ensures comprehensive documentation and helps maintain clear communication among team members and with customers.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_4,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Quickly Access to Information',
      text: `The app offers quick access to all essential information, including quotes, invoices, client details, and price lists. Technicians can easily retrieve this data on-site, enabling them to provide accurate estimates, process payments, and offer exceptional customer service without delay.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_6,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Job Details Forms',
      text: `Job detail forms can be filled in directly from his mobile app when the technician is on site. He will not have to do any paperwork, and this will ensure instinctive and efficient recording of all relevant information or data which will help in faster administrative activity.`,
    },
    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_5,
        alt: 'Streamlined Approval Process',
      },
      list: [],
      href: '#',
      tag: '',
      title: `GPS Tracking and Navigation`,
      text: `The navigation feature aids in arriving at the job site, and tracking through GPS maintains real-time locations of technicians. Moreover, the route optimization feature is built within the field service management applications and provides tools for a technician to prepare the best ways to reach destinations. This leads to better resource allocation and reduced travel time.`,
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec is Right For You?`,
  },
  title: `Why Orcatec is\xa0Right\xa0For\xa0You?`,
  description: `Orcatec is an all-in-one, user-friendly, fully packed, feature-rich, and easy-to-use field service management app that caters to driving a user's operation forward in the most efficient way to optimize productivity.\n\nWhether you have a small team or a large-scale workforce running in your business, Orcatec will have the business tools necessary for your company to thrive in its field. That is why Orcatec is the ultimate solution for your business: `,
  item: [
    {
      title: 'All-in-One Solution',
      description:
        'Powerful and robust, it brings scheduling, dispatching, invoicing, and customer management together. Run your mobile solution for field service and keep your workflow simple without many different tools.',
    },
    {
      title: 'User-Friendly',
      description: `The management system of the Orcatec app is designed to make sure that the user quickly adopts the system. This intuitive interface means that little learning curve is required, so you can start pulling efficiencies straight away.`,
    },
    {
      title: 'Customization',
      description: `It is highly customizable, and Orcatec will be tailor-made to fit your specific business needs. From custom forms to reporting features and integrations with other tools, Orcatec will be adapted to serve properly.`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is a Field Service App?`,
  },
  title: `What Is a Field Service\xa0App?`,
  description: `A field service management app is application software specially designed to organize, optimize, and coordinate field service activities for businesses through a mobile workforce. This is where FSM apps assist business users by managing a mobile workforce through scheduling, dispatching, tracking, and reporting work orders conducted in the field.\n\nIn general, the functionality of an FSM app most probably consists of real-time communication, GPS tracking, inventory, and order management meant for the optimization of all available resources for functional, efficient, and productive customer service. These are widely used applications on how maintenance, repair, installment, or any other service on- or off-site is performed across various industries.`,
  item: [
    {
      title: '',
      description: 'Streamlines scheduling and dispatching.',
    },
    {
      title: '',
      description: 'Enhances communication with real-time updates.',
    },

    {
      title: '',
      description: `Tracks technician performance and job status.`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
  explore,
};
